import { Syncro } from './../models/Syncro';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DataComparison } from '../models/DataComparison';
import { AccueilService } from './accueil.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Client } from '../models/Client';
import { Correspondance } from '../models/Correspondance';
import { CorrespondanceService } from '../correspondance/correspondance.service';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, map, Observable, startWith } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { TableColumn } from '../generic-components/generic-table/class/TableColumn';
import { Dialog } from '@angular/cdk/dialog';
import { MatDialog } from '@angular/material/dialog';
import { DataComparisonDetailsComponent } from './data-comparison-details/data-comparison-details.component';
import {
  MatDatepickerIntl,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  provideMomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from '../utils/MY_DATE_FORMATS';
import * as moment from 'moment';
import { GenericData } from '../models/GenericData';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardInfosComponent } from './dashboard-infos/dashboard-infos.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IncidentService } from '../incident/incident.service';
import { SyncErrComponent } from '../sync-err/sync-err.component';
import { Commentaire } from '../models/Commentaire';
import { CommentaireComponent } from '../commentaire/commentaire.component';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-accueil',
  imports: [
    MainComponent,
    MatTableModule,
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatPaginator,
    NgxSpinnerComponent,
    MatDatepickerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
    MatSortModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatBadgeModule
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './accueil.component.html',
  styleUrl: './accueil.component.css',
})
export class AccueilComponent implements OnInit {
  dataComparison: DataComparison = new DataComparison();

  allSyncro: Syncro[] = [];

  selectedSyncro?: Syncro;

  myControl = new FormControl<string | Correspondance>('');

  correspondanceSelected: Correspondance = new Correspondance();

  correspondances: Correspondance[] = [];

  filteredCorrespondance?: Observable<Correspondance[]>;

  dataComparisons: DataComparison[] = [];

  pageInformations: PageInformations = new PageInformations();

  query: string = '';

  form: FormGroup;

  selectedErrorType: string = ''; // valeur par défaut

  orderBy: string = '';

  commercial: string = '';

  listColumnsResearchable: TableColumn[] = [
    {
      id: 'correspondance.codeDivalto',
      libelle: 'Code divalto',
      property: 'correspondance.codeDivalto',
      type: 'string',
      researchable: true,
    },
    {
      id: 'correspondance.libelleDivalto',
      libelle: 'Libelle divalto',
      property: 'correspondance.libelleDivalto',
      type: 'string',

      researchable: true,
    },
    {
      id: 'dateFinContrat',
      libelle: 'Date fin contrat BIT',
      property: 'dateFinContrat',
      type: 'date',

      researchable: true,
    },
  ];

  displayedModules = [
    { key: 'Postes', label: 'Postes', field: 'nbPostes' },
    { key: 'Serveurs', label: 'Serveurs', field: 'nbServeurs' },
    { key: 'Equipements', label: 'Équipements', field: 'nbEquipements' },
    { key: 'Ats', label: 'ATS', field: 'nbAts' },
    { key: 'Edr', label: 'EDR', field: 'nbEdr' },
    { key: 'Mdr', label: 'MDR', field: 'nbMdr' },
    { key: 'Cry', label: 'CRY', field: 'nbCry' },
    { key: 'Patch', label: 'PATCH', field: 'nbPatch' },
  ];

  dataSources = ['divaltoData', 'rgData', 'bitData'];

  getValue(element: any, source: string, field: string): any {
    return element?.[source]?.[field];
  }

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private searchService: GenericSearchService,
    private spinner: NgxSpinnerService,
    private correspondanceService: CorrespondanceService,
    private accueilService: AccueilService
  ) {
    this.form = this.fb.group({
      correspondance: [''],
      commercial: [''],
      dateFinContrat: [null],
      syncro: [this.selectedSyncro],
    });
  }

  ngOnInit(): void {
    this.correspondanceService.getAllCorrepondance().subscribe((result) => {
      this.correspondances = result;
    });

    this.accueilService.getSyncros().subscribe((result) => {
      this.allSyncro = result;
      this.selectedSyncro = this.allSyncro[this.allSyncro.length - 1];
    });

    this.filteredCorrespondance = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const name = typeof value === 'string' ? value : value?.libelleDivalto;
        return name
          ? this.filterUsers(name as string)
          : this.correspondances.slice();
      })
    );

    this.form
      .get('correspondance')!
      .valueChanges.pipe(debounceTime(300))
      .subscribe((res: any) => {
        this.updateQueryAndReload();
      });

    this.form
      .get('commercial')!
      .valueChanges.pipe(debounceTime(300))
      .subscribe((res: any) => {
        this.updateQueryAndReload();
      });

    this.form.get('dateFinContrat')!.valueChanges.subscribe(() => {
      this.updateQueryAndReload();
    });

    this.form.get('syncro')!.valueChanges.subscribe(() => {
      this.updateQueryAndReload();
    });
  }

  displayedColumns: string[] = [
    'codeDivalto',
    'libelleDivalto',
    'commercial',
    'Entite',
    'divaltoData',
    'rgData',
    'bitData',
    'dateFinContrat',
  ];

  formatDateToEndOfDay(date: Date): string {
    if (moment.isMoment(date)) {
      date = date.toDate();
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois commencent à 0
    const year = date.getFullYear();

    return `${day}/${month}/${year} 23:59:00`;
  }

  toggleSelection(value: string) {
    if (this.selectedErrorType === value) {
      // reclique sur le même → désélection
      this.selectedErrorType = '';
    } else {
      // sinon sélection du nouveau
      this.selectedErrorType = value;
    }
    this.updateQueryAndReload();
  }

  getColorClass(element: DataComparison, property: string): string {
    const alwaysGreen = [
      'divaltoData.nbPostes',
      'divaltoData.nbServeurs',
      'divaltoData.nbEquipements',
      'divaltoData.nbAts',
      'divaltoData.nbEdr',
      'divaltoData.nbMdr',
      'divaltoData.nbCry',
      'divaltoData.nbPatch',
      'bitData.nbEquipements',
      'divaltoData.nbAts',
      'rgData.nbAts',
      'rgData.nbEdr',
      'rgData.nbMdr',
      'rgData.nbCry',
      'rgData.nbPatch',
    ];

    // Cas fixes
    if (alwaysGreen.includes(property)) {
      return 'green-cell';
    }

    // Cas spécifique date
    if (property === 'dateFinContrat') {
      const date = element.dateFinContrat;
      if (!date) return 'blue-cell';
      const result = this.compareToToday(date);
      if (result === 'before') return 'red-cell';
      if (result === 'today') return 'orange-cell';
      return 'green-cell';
    }

    if(element.haveAllIncidentAffranchi){
      return 'green-cell';
    }

    // Découpage property
    const [section, keyStr] = property.split('.');
    if (!section || !keyStr) return 'blue-cell';
    const key = keyStr as keyof GenericData;

    // Valeurs (null -> 0)
    const divaltoValue = element.divaltoData?.[key] ?? 0;
    const bitValue = element.bitData?.[key] ?? 0;
    const rgValue = element.rgData?.[key] ?? 0;

    // Flags de problème (null -> false)
    const hasProblemRgPoste = element.isProblemCorrespondancePosteRg ?? false;
    const hasProblemRgServeur =
      element.isProblemCorrespondanceServeurRg ?? false;
    const hasProblemBitPoste = element.isProblemCorrespondancePosteBit ?? false;
    const hasProblemBitServeur =
      element.isProblemCorrespondanceServeurBit ?? false;

    // Problèmes globaux
    const problemsGlobal =
      hasProblemRgPoste ||
      hasProblemRgServeur ||
      hasProblemBitPoste ||
      hasProblemBitServeur;

    // Problème local
    let currentValue = 0;
    let currentProblem = false;

    if (section === 'bitData') {
      currentValue = bitValue;
      currentProblem =
        (key === 'nbPostes' && hasProblemBitPoste) ||
        (key === 'nbServeurs' && hasProblemBitServeur);
    } else if (section === 'rgData') {
      currentValue = rgValue;
      currentProblem =
        (key === 'nbPostes' && hasProblemRgPoste) ||
        (key === 'nbServeurs' && hasProblemRgServeur);
    } else {
      return 'blue-cell'; // uniquement RG et BIT gérés
    }

    // --- RÈGLES ---
    // Cas spécifique : rgData.nbEquipements < divaltoData.nbEquipements
    if (
      section === 'rgData' &&
      key === 'nbEquipements' &&
      rgValue < divaltoValue
    ) {
      return 'orange-cell';
    }

    // Cas 1 : égalité avec Divalto et pas de problème local => vert
    if (currentValue === divaltoValue && !currentProblem) {
      return 'green-cell';
    }

    // Cas 2 : Divalto > BIT et RG, BIT = RG, pas de problème global => vert clair
    if (
      divaltoValue > bitValue &&
      divaltoValue > rgValue &&
      bitValue === rgValue &&
      !problemsGlobal
    ) {
      return 'green-light-cell';
    }

    // Cas 3 : Divalto > BIT et RG, mais RG != BIT ou problème global => orange
    if (
      divaltoValue >= bitValue &&
      divaltoValue >= rgValue &&
      (bitValue !== rgValue || problemsGlobal)
    ) {
      return 'orange-cell';
    }

    // Cas 4 : Divalto < BIT ou RG, BIT = RG, pas de problème global => rouge
    if (
      (divaltoValue < bitValue || divaltoValue < rgValue) &&
      bitValue === rgValue &&
      !problemsGlobal
    ) {
      return 'red-cell';
    }

    // Cas 5 : Divalto < BIT ou RG, et (RG != BIT ou problème global) => rouge foncé
    if (
      (divaltoValue < bitValue || divaltoValue < rgValue) &&
      (bitValue !== rgValue || problemsGlobal)
    ) {
      return 'red-dark-cell';
    }

    // Cas oublié
    return 'blue-cell';
  }

  displayClient(correspondance?: Correspondance) {
    if (correspondance?.codeDivalto == undefined) {
      return '';
    } else {
      return `${correspondance.libelleDivalto} (${correspondance.codeDivalto})`;
    }
  }

  clientSelected(value: any) {
    this.correspondanceSelected = value.option.value;
    this.updateQueryAndReload();
  }

  filterUsers(event: any): Correspondance[] {
    return this.correspondances.filter((correspondance) =>
      correspondance.libelleDivalto.toLowerCase().includes(event.toLowerCase())
    );
  }

  onPageEvent(event: any) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.updateQueryAndReload();
  }

  loadDataComparisons(query?: string) {
    this.spinner.show();
    if (!query) {
      query = 'isDeleted=false';
    }
    this.searchService
      .search(
        'comparison',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.pageSize,
        this.orderBy
      )
      .subscribe(
        (result) => {
          this.dataComparisons = result.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            result
          );
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  onRowClicked(row: any) {
    const dialog = this.dialog.open(DataComparisonDetailsComponent, {
      backdropClass: 'blurred-backdrop',
      data: row,
      width: '90vw',
      maxWidth: '95vw',
    });
  }

  shouldShow(element: DataComparison, type: any): boolean {
    const key = `nb${type}` as keyof GenericData;
    return (
      element.divaltoData?.[key] !== 0 ||
      element.bitData?.[key] !== 0 ||
      element.rgData?.[key] !== 0
    );
  }

  getCellSplitClass(element: any, source: any): string {
    let count = 0;
    if (this.shouldShow(element, 'Postes')) count++;
    if (this.shouldShow(element, 'Serveurs')) count++;
    if (this.shouldShow(element, 'Equipements')) count++;
    if (this.shouldShow(element, 'Ats')) count++;
    if (this.shouldShow(element, 'Edr')) count++;
    if (this.shouldShow(element, 'Mdr')) count++;
    if (this.shouldShow(element, 'Cry')) count++;
    if (this.shouldShow(element, 'Patch')) count++;

    return count === 1 ? 'single-cell-part' : 'cell-split';
  }

  compareToToday(dateInput: string | Date): 'before' | 'today' | 'after' {
    const dateToCompare = new Date(dateInput); // Conversion explicite
    const today = new Date();
    const todayAtMidnight = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const inputAtMidnight = new Date(
      dateToCompare.getFullYear(),
      dateToCompare.getMonth(),
      dateToCompare.getDate()
    );

    if (inputAtMidnight.getTime() < todayAtMidnight.getTime()) {
      return 'before';
    } else if (inputAtMidnight.getTime() > todayAtMidnight.getTime()) {
      return 'after';
    } else {
      return 'today';
    }
  }

  openInfos() {
    this.dialog.open(DashboardInfosComponent, {
      backdropClass: 'blurred-backdrop',
    });
  }

  updateQueryAndReload() {
    console.log(this.commercial);

    const correspondance = this.form.get('correspondance')!.value;
    const date = this.form.get('dateFinContrat')!.value;
    let correspondancePart = '';
    let datePart = '';
    let query = '';

    if (correspondance) {
      const value =
        typeof correspondance === 'string'
          ? correspondance
          : correspondance.libelleDivalto;

      const subQueries = this.listColumnsResearchable
        .filter((col) => col.type === 'string')
        .map((col) => {
          const property = col.searchOn || col.id;
          return `${property}==*${value}*`;
        });

      if (subQueries.length > 0) {
        correspondancePart = `(${subQueries.join(',')})`;
      }

      this.pageInformations.pageIndex = 0;
    }

    // Format date
    if (date) {
      const formattedDate = this.formatDateToEndOfDay(date);
      datePart = `dateFinContrat<=${formattedDate}`;
      this.pageInformations.pageIndex = 0;
    }

    // Définition des conditions d’erreur selon le filtre choisi
    let ecartRgConditions: string[] = [];
    let ecartBitConditions: string[] = [];
    let problems: string[] = [];

    if (this.selectedErrorType == 'all') {
      // 👉 tous les écarts possibles (erreurs commerciales + techniques)
      ecartRgConditions = [
        'ecartRg.ecartPoste!=0',
        'ecartRg.ecartServeur!=0',
        'ecartRg.ecartEquipement!=0',
        'ecartRg.ecartAts!=0',
        'ecartRg.ecartEdr!=0',
        'ecartRg.ecartMdr!=0',
        'ecartRg.ecartCry!=0',
        'ecartRg.ecartPatch!=0',
      ];
      ecartBitConditions = [
        'ecartBit.ecartPoste!=0',
        'ecartBit.ecartServeur!=0',
        'ecartBit.ecartEquipement!=0',
        'ecartBit.ecartAts!=0',
        'ecartBit.ecartEdr!=0',
        'ecartBit.ecartMdr!=0',
        'ecartBit.ecartCry!=0',
        'ecartBit.ecartPatch!=0',
      ];
      problems = [
        'haveEcartRg==true',
        'haveEcartBit==true',
        'isProblemCorrespondancePosteBit==true',
        'isProblemCorrespondanceServeurBit==true',
        'isProblemCorrespondancePosteRg==true',
        'isProblemCorrespondanceServeurRg==true',
      ];
    } else if (this.selectedErrorType == 'commercial') {
      // 👉 erreurs commerciales = rouge / rouge foncé
      // Divalto < BIT ou Divalto < RG
      ecartRgConditions = [
        'haveEcartRg==true;(ecartRg.ecartPoste>0,ecartRg.ecartServeur>0,ecartRg.ecartEquipement>0,ecartRg.ecartAts>0,ecartRg.ecartEdr>0,ecartRg.ecartMdr>0,ecartRg.ecartCry>0,ecartRg.ecartPatch>0)',
      ];
      ecartBitConditions = ['haveEcartBit==true;(ecartBit.ecartPoste>0,ecartBit.ecartServeur>0,ecartBit.ecartEquipement>0,ecartBit.ecartAts>0,ecartBit.ecartEdr>0,ecartBit.ecartMdr>0,ecartBit.ecartCry>0,ecartBit.ecartPatch>0)'];
      problems = []; // pas besoin des problèmes techniques
    } else if (this.selectedErrorType == 'technical') {
      // 👉 erreurs techniques = orange / rouge foncé
      // RG != BIT ou erreurs de correspondance postes/serveurs
      ecartRgConditions = [
        'isProblemCorrespondancePosteRg==true',
        'isProblemCorrespondanceServeurRg==true',
      ];
      ecartBitConditions = [
        'isProblemCorrespondancePosteBit==true',
        'isProblemCorrespondanceServeurBit==true',
      ];
      problems = []; // pas besoin des écarts commerciaux purs
    }
    let errorGroups = [''];
    if (problems.length == 0) {
      errorGroups = [
        `(${ecartRgConditions.join(',')})`,
        `(${ecartBitConditions.join(',')})`,
      ];
    } else {
      errorGroups = [
        `(${ecartRgConditions.join(',')})`,
        `(${ecartBitConditions.join(',')})`,
        `(${problems.join(',')})`,
      ];
    }

    const errorsCombined = `((${errorGroups.join(',')}))`;

    const allowedAll = ['commercial', 'all', 'technical'];

    // Construction de la query
    if (
      !correspondancePart &&
      allowedAll.includes(this.selectedErrorType) &&
      !datePart
    ) {
      const todayFormatted = this.formatDateToEndOfDay(new Date());
      query = `(dateFinContrat<=${todayFormatted}),${errorGroups.join(',')}`;
    } else if (
      !correspondancePart &&
      allowedAll.includes(this.selectedErrorType) &&
      datePart
    ) {
      query = `${datePart};${errorsCombined}`;
    } else if (
      correspondancePart &&
      allowedAll.includes(this.selectedErrorType) &&
      !datePart
    ) {
      query = `${correspondancePart};${errorsCombined}`;
    } else if (
      correspondancePart &&
      datePart &&
      allowedAll.includes(this.selectedErrorType)
    ) {
      query = `${correspondancePart};${datePart};${errorsCombined}`;
    } else if (
      correspondancePart &&
      datePart &&
      !allowedAll.includes(this.selectedErrorType)
    ) {
      query = `${correspondancePart};${datePart}`;
    } else if (
      correspondancePart &&
      !datePart &&
      !allowedAll.includes(this.selectedErrorType)
    ) {
      query = correspondancePart;
    } else if (
      !correspondancePart &&
      datePart &&
      !allowedAll.includes(this.selectedErrorType)
    ) {
      query = datePart;
    }

    // Si vide
    if (!query) {
      query = '';
    }

    // ici on ajoute toujours le selectedSyncro
    if (this.selectedSyncro && this.selectedSyncro.idSyncro) {
      query = query
        ? `(${query});syncro.idSyncro=${this.selectedSyncro.idSyncro}`
        : `syncro.idSyncro=${this.selectedSyncro.idSyncro}`;
    }

    const commercial = this.form.get('commercial')?.value;
    if (commercial && commercial !== '') {
      query = query
        ? `${query};commercial=${commercial}`
        : `commercial=${commercial}`;
    }

    this.loadDataComparisons(query);
  }

  sortChange(sortState: Sort) {
    if (sortState.direction == '') {
      this.orderBy = '';
      this.updateQueryAndReload();
      return;
    }

    if (sortState.active == 'codeDivalto') {
      this.orderBy = `correspondance.codeDivalto=${sortState.direction}`;
    } else if (sortState.active == 'libelleDivalto') {
      this.orderBy = `correspondance.libelleDivalto=${sortState.direction}`;
    } else if (sortState.active == 'divaltoData') {
      this.orderBy =
        `divaltoData.nbPostes=${sortState.direction},` +
        `divaltoData.nbServeurs=${sortState.direction},` +
        `divaltoData.nbEquipements=${sortState.direction},` +
        `divaltoData.nbAts=${sortState.direction},` +
        `divaltoData.nbEdr=${sortState.direction},` +
        `divaltoData.nbMdr=${sortState.direction},` +
        `divaltoData.nbCry=${sortState.direction},` +
        `divaltoData.nbPatch=${sortState.direction}`;
    } else {
      this.orderBy = `${sortState.active}=${sortState.direction}`;
    }

    this.updateQueryAndReload();
  }

  exportCsv() {
    this.accueilService
      .downloadCsv(this.selectedSyncro?.idSyncro)
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'data_comparison.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }


  openErrorLogs(){
    this.dialog.open(SyncErrComponent, {
      backdropClass: 'blurred-backdrop',
      width: '600px',
      data: {
        idSyncro: this.selectedSyncro?.idSyncro
      }
    });
  }


  getTexteContrat(element:DataComparison){
    if(element.bitData){
      const allZero = Object.values(element.bitData).every(v => (v ?? 0) === 0);
      return allZero ? '' : 'Pas de contrat BIT'
    }
    return 'Pas de contrat BIT'
  }


  showCommentaire(element:DataComparison){
   
    const dialogRef = this.dialog.open(CommentaireComponent, {
      width: '700px',
      backdropClass: 'blurred-backdrop',
      disableClose: true,
      data: { codeDivalto: element.correspondance?.codeDivalto }
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        element.commentaires = result;
        this.dataComparisons = [...this.dataComparisons];
      }
    });
  }


  
}
